import React from 'react';
import './GameResult.css';

const GameResult = ({ winner, playerSymbol, onNewGame, onChangeSettings }) => {
  const getResultMessage = () => {
    if (winner === 'draw') {
      return "It's a Draw!";
    } else if (winner === playerSymbol) {
      return "You Won!";
    } else {
      return "Computer Wins!";
    }
  };

  const getResultEmoji = () => {
    if (winner === 'draw') {
      return "🤝";
    } else if (winner === playerSymbol) {
      return "🎉";
    } else {
      return "🤖";
    }
  };

  const getResultClass = () => {
    if (winner === 'draw') {
      return 'draw';
    } else if (winner === playerSymbol) {
      return 'win';
    } else {
      return 'loss';
    }
  };

  return (
    <div className={`game-result ${getResultClass()}`}>
      <div className="result-content">
        <div className="result-emoji">{getResultEmoji()}</div>
        <h2 className="result-message">{getResultMessage()}</h2>
        <div className="result-buttons">
          <button className="new-game-btn" onClick={onNewGame}>
            Play Again
          </button>
          <button className="change-settings-btn" onClick={onChangeSettings}>
            Change Settings
          </button>
        </div>
      </div>
    </div>
  );
};

export default GameResult;